export const SUB_NONE = 'none';
export const SUB_SPECIAL = 'special'; // e.g. admin, invitees
export const SUB_TRIALING = 'trialing';
export const SUB_TRIAL_EXPIRED = 'trial_expired';
export const SUB_ACTIVE = 'active';
export const SUB_ACTIVE_PENDING = 'active_pending';
export const SUB_CANCEL = 'canceled';
export const SUB_SCHEDULED_TO_CANCEL = 'scheduled_to_cancel';
export const SUB_PAST_DUE = 'past_due';
export const SUB_PAUSED = 'paused';

